// AddGmstr.jsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

const AddGmstr = () => {
  const routeLocation = useLocation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};

  const [editId, setEditId] = useState(null);
  const [parentGroups, setParentGroups] = useState([]);

  const [form, setForm] = useState({
    group_name: "",
    group_code: "",
    parent_group_id: "",
  });

const fetchParentGroups = async () => {
  try {
    const response = await axios.get(`${baseUrl}/parent_group_read/`, {
      params: { school_id: userObj.school_id },
    });

    // ✅ Show only Active records
    const activeGroups = (response.data.parent_groups || []).filter(
      (group) => group.is_active === "Active"
    );

    setParentGroups(activeGroups);
  } catch (error) {
    console.log("Error fetching parent groups:", error?.response?.data || error.message);
  }
};
  useEffect(() => {
    fetchParentGroups();
  }, []);

  // ✅ Edit Mode
  useEffect(() => {
    if (routeLocation.state?.groupData) {
      const data = routeLocation.state.groupData;
      setEditId(data.group_id);
      setForm({
        group_name: data.group_name || "",
        group_code: data.group_code || "",
        parent_group_id: data.parent_group_id || "",
      });
      window.history.replaceState({}, document.title);
    }
  }, [routeLocation]);

  // ✅ Input Change
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prev) => ({ ...prev, [id]: value }));
  };

  // ✅ Reset
  const handleReset = () => {
    setForm({ group_name: "", group_code: "", parent_group_id: "" });
    setEditId(null);
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      group_id: editId || null,
      group_name: form.group_name,
      group_code: form.group_code,
      parent_group_id: form.parent_group_id || null,
      school_id: userObj.school_id,
      user: userObj.user_name,
      action: editId ? "UPDATE" : "CREATE",
    };

    try {
      await axios.post(`${baseUrl}/groupscreateupdate/`, payload, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success(editId ? "Record Updated Successfully" : "Record Added Successfully");
      window.history.back();
    } catch (error) {
      console.error("Error:", error?.response?.data || error.message);

      // ✅ TC4 FIX: Extract only first line — strips "\nCONTEXT: PL/pgSQL function..." noise
      const rawMsg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Unexpected error occurred";

      const msg = rawMsg.split("\n")[0].trim(); // ✅ "group_name already exists" only

      // ✅ TC4 FIX: Map backend key to user-friendly message
      const friendlyMsg =
        msg.toLowerCase().includes("already exists")
          ? "Record already exists"
          : msg;

      toast.error(friendlyMsg);
    }
  };

  return (
    <div className="pageBody">
      <ToastContainer />
      <Container fluid>
        <Card>
          <Card.Body>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col xs={12}>
                  <h6 className="commonSectionTitle">Group Details</h6>
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Parent Group Name<span className="requiredStar">*</span>
                      </Form.Label>
                      <select
                        className="form-select"
                        required
                        id="parent_group_id"
                        value={form.parent_group_id}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled hidden>
                          Select Parent Group Name
                        </option>
                        {parentGroups.map((group) => (
                          <option key={group.parent_group_id} value={group.parent_group_id}>
                            {group.parent_group_name}
                          </option>
                        ))}
                      </select>
                    </Form.Group>
                  </div>
                </Col>

                {/* Group Name */}
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>
                        Group Name <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        id="group_name"
                        value={form.group_name}
                        placeholder="Enter Group Name"
                        maxLength={50}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </div>
                </Col>

                {/* Group Code */}
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <div className="commonInput">
                    <Form.Group>
                      <Form.Label>Group Code</Form.Label>
                      <Form.Control
                        type="text"
                        id="group_code"
                        value={form.group_code}
                        placeholder="Enter Group Code"
                        maxLength={20}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </div>
                </Col>
              </Row>

              {/* Buttons */}
              <div className="d-flex justify-content-between mt-3">
                <div>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn-info clearBtn"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </div>

                <div>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn-danger secondaryBtn me-2"
                    onClick={() => window.history.back()}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="submit"
                    variant="primary"
                    className="btn-success primaryBtn"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default AddGmstr;